// extracted by mini-css-extract-plugin
module.exports = {"Toolbar":"Toolbar_Toolbar__3W45e","Logo":"Toolbar_Logo__3n_4d","DesktopOnly":"Toolbar_DesktopOnly__1IrS2"};